"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = OverviewLocations;
var jsx_runtime_1 = require("react/jsx-runtime");
var overviewStyles = __importStar(require("./OverviewLocations.module.scss"));
var react_redux_1 = require("react-redux");
var OverviewLocationsElement_1 = __importDefault(require("./OverviewLocationsElement"));
var sidebarTranslator_1 = require("@components/Sidebar/localisation/sidebarTranslator");
var useCurrentLanguage_1 = require("@hooks/useCurrentLanguage");
var locationFormTranslator_1 = require("@components/Forms/LocationForm/localisation/locationFormTranslator");
function OverviewLocations() {
    var locations = (0, react_redux_1.useSelector)(function (state) { return state.locationsSlice; }).locations;
    var characters = (0, react_redux_1.useSelector)(function (state) { return state.charactersSlice; }).characters;
    var currentLang = (0, useCurrentLanguage_1.useCurrentLanguage)();
    if (locations.length === 0)
        return;
    var headerName = sidebarTranslator_1.sidebarTranslator[currentLang].locations;
    var t = locationFormTranslator_1.locationsFormTranslator[currentLang];
    return ((0, jsx_runtime_1.jsxs)("div", { className: overviewStyles.overview_container, id: "locations", children: [(0, jsx_runtime_1.jsx)("h2", { className: overviewStyles.overview_header, children: headerName }), (0, jsx_runtime_1.jsx)("ul", { style: { listStyle: "none", margin: 0, padding: 0 }, children: locations.map(function (location) { return ((0, jsx_runtime_1.jsx)("li", { className: overviewStyles.location_item, children: (0, jsx_runtime_1.jsx)(OverviewLocationsElement_1.default, { t: t, location: location, characters: characters }) }, location.id)); }) })] }));
}
